import { Splide } from "@splidejs/splide";

export const customSplide = () => {
  if (window.document.body.id === 'top') {
    const slider1 = new Splide('.splide1',{
      // arrows: false, // 矢印ボタンを非表示
      pagination: false, // ページネーションを非表示
      // autoplay: true, //自動再生
      perPage: 1,
      // breakpoints: {
      //   767: {
      //     perPage: 1,
      //   },
      // },
      // gap: "2rem", // ギャップの指定
      // interval: 6000, // 自動再生の間隔
      type: "silde", // スライド
      rewind: false, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
      speed: 1000, // スライダーの移動時間
    }).mount();

    // const slider2 = new Splide('.splide2',{
    //   // arrows: false, // 矢印ボタンを非表示
    //   pagination: false, // ページネーションを非表示
    //   autoplay: true, //自動再生
    //   perPage: 1,
    //   // breakpoints: {
    //   //   767: {
    //   //     perPage: 1,
    //   //   },
    //   // },
    //   // gap: "2rem", // ギャップの指定
    //   interval: 6000, // 自動再生の間隔
    //   type: "slide", // スライド
    //   rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
    //   speed: 3000, // スライダーの移動時間
    // }).mount();
  }
}
